function Recaptcha()
{
    this.auto = function(form, type){
        var element = $("#"+form);

        if(element.length <= 0)
        {
            return;
        }

        $(element).on("submit", function (event) {
            event.preventDefault();
        });
    };

    this.validate = function(form, type, callback){
        grecaptcha.ready(function(){
            grecaptcha.execute("6LdBq5IUAAAAAP-VRhp_tkBt3YNbgjMMeigpaMr1", {action: type }).then(function(token){
                $(form).find("[name='g-recaptcha-response']").remove();
                $(form).append("<input type='hidden' name='g-recaptcha-response' value='"+token+"' />");

                callback();
            });
        });
    };
}

var captcha = new Recaptcha();
//captcha.auto("#submit-ticket-form", "homepage");